// import useScrollToTop from 'hooks/useScrollToTop';
// import React, { useEffect, useState } from 'react'
// import { BASE_APIURL, sanitizeTitle, truncateText } from 'utils/helpers';
// import { Link } from 'react-router-dom';
// import "./Blogs.css"
// import bgimg from "../../images/Agile.jpg";
// import cloudAdoptionBlogImg from "images/cloudadoptionblog.jpg"
// import LoaderSpiner from 'Components/LoaderSpiner';

// import img1 from '../../images/card/1.jpg';
// import img2 from '../../images/card/2.jpg';
// import img3 from '../../images/card/3.jpg';
// import img4 from '../../images/card/4.jpg';
// import img5 from '../../images/card/5.jpg';
// import img6 from '../../images/card/6.jpg';
// import img7 from '../../images/card/7.jpg';

// const categories = [
//   "Artificial Intelligence",
//   "Blog",
//   "Cloud",
//   "Data Science",
//   "Digital",
//   "IT Service",
//   "Management",
//   "Marketing"
// ];

// const Blogs = () => {
//   useScrollToTop()
//   const imageArray = [
//     { id: 1, src: img1 },
//     { id: 2, src: img2 },
//     { id: 3, src: img3 },
//     { id: 4, src: img4 },
//     { id: 5, src: img5 },
//     { id: 6, src: img6 },
//     { id: 7, src: img7 },
//   ];

//   const [blogs, setBlogs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const extractTitle = (htmlContent) => {
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(htmlContent, 'text/html');
//     const title = doc.querySelector('h1, h2')?.innerText || 'Untitled';
//     return title;
//   };

//   const extractContentSnippet = (htmlContent, length = 200) => {
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(htmlContent, 'text/html');
//     const content = doc.body.innerText || ''; // Extract plain text from the HTML body
//     return content.substring(0, length) + '...'; // Return a snippet of content
//   };

//   // Fetch blogs from backend on component mount
//   useEffect(() => {
//     const fetchBlogs = async () => {
//       try {
//         // Fetching blogs from backend API
//         const response = await fetch(`${BASE_APIURL}/get-blogs`);

//         if (!response.ok) {
//           throw new Error('Failed to fetch blogs');
//         }

//         const data = await response.json();
//         setBlogs(data.htmlFiles); // The array of HTML files
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBlogs();
//   }, []);

//   console.log("nlogs", blogs)

//   if (loading) return <div><LoaderSpiner /></div>;

//   // Show error state if an error occurs
//   if (error) return <div>Error: {error}</div>;

//   return (
//     <div>
//       {/* <Navbar/> */}
//       <div className="  relative w-full ">
//         <div className="absolute inset-0 bg-black opacity-50"></div>
//         <div className="relative bg-cover bg-center bg-no-repeat h-96  " style={{ backgroundImage: `url(${bgimg})` }}>
//           <div className="relative z-10   top-40 text-center text-white">
//             <h2 className="text-6xl w-1/2 -ml-40 font-bold mb-4"> INSIGHT</h2>

//           </div>
//         </div>
//       </div>
//       <div className="p-6 mx-auto space-y-6 bg-white max-w-8xl rounded-xl">
//         <h2 className="text-4xl font-bold text-center text-gray-800">OUR LATEST BLOG</h2>
//         <div className="flex flex-wrap justify-center gap-4 text-center">
//           {categories.map((category, index) => (
//             <span
//               key={index}
//               className="px-3 py-2 text-lg font-semibold text-white bg-orange-400"
//             >
//               {category}
//             </span>
//           ))}
//         </div>

//       </div>

//       <div className="w-full p-8 mx-auto max-w-7xl">
//         <h2 className="mb-6 text-3xl font-bold">Case Studies</h2>
//         <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
//         {blogs?.map((blog, index) => (
//   <div
//     key={blog.key}
//     className="items-center overflow-hidden text-center bg-white rounded-lg shadow-xl"
//   >
//     <div className="relative">
//       <img
//         src={imageArray[index].src}
//         className="object-cover w-full h-48"
//         alt={blog.title || "Blog Image"}
//       />

//               </div>
//               <div className="p-6">
//                 <h3 className="mb-2 text-lg font-semibold">
//                   {extractTitle(blog.content)}
//                 </h3>
//                 <p className="mb-4 text-gray-600">
//                   {extractContentSnippet(blog.content)}
//                 </p>

//                 <Link to={`/insights/${blog.key.split("/")[1]}`}>
//                   <button className='p-1 px-2 bg-blue-500 hover:scale-110'>
//                     <span className="text-sm font-normal text-white">Learn More</span>
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           ))}

//         </div>
//       </div>

//       {/* <div className="w-full p-8 mx-auto max-w-7xl ">
//         <h2 className="mb-6 text-3xl font-bold">Case Studies</h2>
//         <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
//           {blogs?.map((blog) => (
//             <div key={blog.key} className="items-center overflow-hidden text-center bg-white rounded-lg shadow-xl">
//               <div className="relative">
//                 <img src={image} alt={title} className="object-cover w-full h-48" />
//               </div>
//               <div className="p-6">
//                 <h3 className="mb-2 text-lg font-semibold">{title}</h3>
//                 <p className="mb-4 text-gray-600">{blog.content.substring(0, 200)}</p>
//                 <Link to={`/insights/${sanitizeTitle(title)}`}>
//                   <button className='p-1 px-2 bg-orange-400 rounded-md hover:scale-110'>
//                     <span className="text-sm font-normal text-white">Learn More</span>
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div> */}

//       {/* <h1>Blogs</h1>
//       <div style={{ width: "80%", margin: "0 auto", textAlign: "center" }} className="blogs-container">
//         {blogs.length === 0 && <div>No blogs available</div>}
//         {blogs.map((blog) => (
//           <div
//             key={blog.key}
//             style={{
//               marginTop: "20px",
//               padding: "20px",
//               textAlign: "left",
//               borderBottom: "1px solid #ccc",
//               maxWidth: "1000px",
//               margin: "20px auto",
//             }}
//             className="custom-blog-content"
//           >
//             <h2>{blog.key.split("/").pop().replace(".html", "")}</h2>
//             <div dangerouslySetInnerHTML={{ __html: blog.content }} />
//           </div>
//         ))}
//       </div> */}

//       {/* <Footer/> */}

//     </div>

//   );
// };

// export default Blogs

// import useScrollToTop from "hooks/useScrollToTop";
// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { BASE_APIURL } from "utils/helpers";
// import { Link } from "react-router-dom";
// import "./Blogs.css";
// import bgimg from "../../images/Agile.jpg";
// import LoaderSpiner from "Components/LoaderSpiner";

// const Blogs = () => {
//   useScrollToTop();

//   // State
//   const [blogs, setBlogs] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [activeCategory, setActiveCategory] = useState("All");

//   // Pagination states
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const limit = 6; // blogs per page

//   // Ref for infinite scroll observer
//   const observerRef = useRef(null);

//   // Fetch categories
//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const response = await fetch(`${BASE_APIURL}/api/categories`);
//         if (!response.ok) throw new Error("Failed to fetch categories");
//         const data = await response.json();
//         setCategories(["All", ...data.categories]); // Add "All" as default
//       } catch (err) {
//         console.error("Error fetching categories:", err.message);
//         setCategories(["All"]);
//       }
//     };
//     fetchCategories();
//   }, []);

//   // Fetch blogs
//   const fetchBlogs = async (reset = false) => {
//     setLoading(true);
//     try {
//       let url =
//         activeCategory === "All"
//           ? `${BASE_APIURL}/api/all-posts?page=${page}&limit=${limit}`
//           : `${BASE_APIURL}/api/posts/category/${encodeURIComponent(
//               activeCategory
//             )}?page=${page}&limit=${limit}`;

//       const response = await fetch(url);
//       if (!response.ok) throw new Error("Failed to fetch blogs");

//       const data = await response.json();
//       const newPosts = data.posts || data;

//       if (reset) {
//         setBlogs(newPosts);
//       } else {
//         setBlogs((prev) => [...prev, ...newPosts]);
//       }

//       setHasMore(newPosts.length === limit);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Reload blogs when category changes
//   useEffect(() => {
//     setPage(1);
//     fetchBlogs(true);
//   }, [activeCategory]);

//   // Load more blogs when page changes
//   useEffect(() => {
//     if (page > 1) {
//       fetchBlogs(false);
//     }
//   }, [page]);

//   // Infinite scroll observer
//   const lastBlogRef = useCallback(
//     (node) => {
//       if (loading) return;
//       if (observerRef.current) observerRef.current.disconnect();

//       observerRef.current = new IntersectionObserver((entries) => {
//         if (entries[0].isIntersecting && hasMore) {
//           setPage((prev) => prev + 1);
//         }
//       });

//       if (node) observerRef.current.observe(node);
//     },
//     [loading, hasMore]
//   );

//   // UI States
//   if (loading && blogs.length === 0)
//     return (
//       <div>
//         <LoaderSpiner />
//       </div>
//     );
//   if (error) return <div className="text-red-500">Error: {error}</div>;

//   return (
//     <div>
//       {/* Hero Banner */}
//       <div className="relative w-full">
//         <div className="absolute inset-0 bg-black opacity-50"></div>
//         <div
//           className="relative bg-cover bg-center bg-no-repeat h-96"
//           style={{ backgroundImage: `url(${bgimg})` }}
//         >
//           <div className="relative z-10 top-40 text-center text-white">
//             <h2 className="text-6xl w-1/2 -ml-40 font-bold mb-4">INSIGHT</h2>
//           </div>
//         </div>
//       </div>

//       {/* Categories Filter */}
//       <div className="p-6 mx-auto space-y-6 bg-white max-w-8xl rounded-xl">
//         <h2 className="text-4xl font-bold text-center text-gray-800">
//           OUR LATEST BLOG
//         </h2>
//         <div className="flex flex-wrap justify-center gap-4 text-center">
//           {categories.map((category, index) => (
//             <button
//               key={index}
//               onClick={() => setActiveCategory(category)}
//               className={`px-3 py-2 text-lg font-semibold rounded ${
//                 activeCategory === category
//                   ? "bg-orange-500 text-white"
//                   : "bg-gray-200 text-gray-800"
//               }`}
//             >
//               {category.toUpperCase()}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Blog Cards */}
//       <div className="w-full p-8 mx-auto max-w-7xl">
//         <h2 className="mb-6 text-3xl font-bold">Case Studies</h2>
//         <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
//           {blogs?.length > 0 ? (
//             blogs.map((blog, index) => {
//               const isLastBlog = blogs.length === index + 1;
//               return (
//                 <div
//                   ref={isLastBlog ? lastBlogRef : null}
//                   key={blog.key}
//                   className="items-center overflow-hidden text-center bg-white rounded-lg shadow-xl"
//                 >
//                   {/* Thumbnail */}
//                   <img
//                     src={
//                       blog.thumbnail ||
//                       "https://via.placeholder.com/400x200?text=No+Image"
//                     }
//                     className="object-cover w-full h-48"
//                     alt={blog.title || "Blog Image"}
//                   />
//                   {/* Blog Content */}
//                   <div className="p-6">
//                     <h3 className="mb-2 text-lg font-semibold">
//                       {blog.title || "Untitled"}
//                     </h3>
//                     <p className="mb-4 text-gray-600">
//                       {blog.content
//                         ? blog.content
//                             .replace(/<[^>]+>/g, "")
//                             .substring(0, 200) + "..."
//                         : "No content available."}
//                     </p>
//                     <Link
//                       to={`/insights/${encodeURIComponent(blog.key)}`}
//                       state={{ blog }}
//                     >
//                       <button className="p-1 px-2 bg-blue-500 hover:scale-110">
//                         <span className="text-sm font-normal text-white">
//                           Learn More
//                         </span>
//                       </button>
//                     </Link>
//                   </div>
//                 </div>
//               );
//             })
//           ) : (
//             <p className="text-gray-500">
//               No blogs available in this category.
//             </p>
//           )}
//         </div>

//         {/* Loader Spinner at bottom when fetching */}
//         {loading && (
//           <div className="flex justify-center mt-6">
//             <LoaderSpiner />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Blogs;

import useScrollToTop from "hooks/useScrollToTop";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { BASE_APIURL, slugify } from "utils/helpers";
import { Link } from "react-router-dom";
import "./Blogs.css";
import bgimg from "../../images/Agile.jpg";
import LoaderSpiner from "Components/LoaderSpiner";

const Blogs = () => {
  useScrollToTop();

  // State
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeCategory, setActiveCategory] = useState("All");

  // Pagination states
  // const [page, setPage] = useState(1);
  const [continuationToken, setContinuationToken] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const limit = 3; // blogs per page

  // Ref for infinite scroll observer
  const observerRef = useRef(null);
  const abortControllerRef = useRef(null);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${BASE_APIURL}/api/blogs/categories`);
        if (!response.ok) throw new Error("Failed to fetch categories");
        const data = await response.json();
        setCategories(["All", ...data.categories]); // Add "All" as default
      } catch (err) {
        console.error("Error fetching categories:", err.message);
        setCategories(["All"]);
      }
    };
    fetchCategories();
  }, []);

  // Fetch with retry
  const fetchWithRetry = async (
    url,
    options = {},
    retries = 3,
    delay = 1000
  ) => {
    try {
      const res = await fetch(url, options);
      if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
      return await res.json();
    } catch (err) {
      if (retries > 0) {
        console.warn(`⚠️ Fetch failed, retrying... (${3 - retries + 1})`);
        await new Promise((resolve) => setTimeout(resolve, delay)); // wait before retry
        return fetchWithRetry(url, options, retries - 1, delay);
      }
      throw err; // final failure
    }
  };
  // Fetch blogs
  // const fetchBlogs = async (reset = false) => {
  //   setLoading(true);
  //   try {
  //     let url =
  //       activeCategory === "All"
  //         ? `${BASE_APIURL}/api/blogs/all-posts?limit=${limit}`
  //         : `${BASE_APIURL}/api/blogs/posts/category/${encodeURIComponent(
  //             activeCategory
  //           )}?limit=${limit}`;

  //           if (continuationToken && !reset) {
  //     url += `&continuationToken=${continuationToken}`;
  //   }

  //     // const response = await fetch(url);
  //     // if (!response.ok) throw new Error("Failed to fetch blogs");

  //     //  const data = await response.json();
  //     const data = await fetchWithRetry(url, {}, 3, 1000);
  //      const newPosts = data.posts || data;

  //     if (reset) {
  //       setBlogs(newPosts);
  //     } else {
  //       setBlogs((prev) => [...prev, ...newPosts]);
  //     }

  //     setHasMore(data.hasMore); // Updated to use hasMore from backend
  //         setContinuationToken(data.nextContinuationToken);  // 👈 NEW

  //   } catch (err) {
  //     console.error("❌ Blog fetch failed:", err);  // Debugging only
  //     setError("Failed to fetch blogs");

  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // NOTE: fetchWithRetry already accepts an options object and forwards it to fetch
  const fetchBlogs = async (
    reset = false,
    tokenOverride = null,
    categoryOverride = undefined
  ) => {
    const categoryToUse =
      categoryOverride !== undefined ? categoryOverride : activeCategory;

    // Abort previous request (if any)
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;
    const signal = controller.signal;

    setLoading(true);
    try {
      // Build URL using explicit categoryToUse (not the possibly stale closure)
      let url =
        categoryToUse === "All"
          ? `${BASE_APIURL}/api/blogs/all-posts/short-summary?limit=${limit}`
          : `${BASE_APIURL}/api/blogs/posts/category-summary/${encodeURIComponent(
              categoryToUse
            )}?limit=${limit}`;

      // Choose token: explicit override first, else keep existing state token only if not resetting.
      const tokenToUse =
        tokenOverride !== null
          ? tokenOverride
          : !reset
          ? continuationToken
          : null;
      if (tokenToUse) {
        url += `&continuationToken=${encodeURIComponent(tokenToUse)}`;
      }

      const data = await fetchWithRetry(url, { signal }, 3, 1000);

      // If category has changed since this fetch started, ignore the stale result
      if (categoryToUse !== activeCategory) {
        // do not update state with stale results
        return;
      }

      const newPosts = data.posts || [];

      if (reset) {
        setBlogs(newPosts);
      } else {
        setBlogs((prev) => [...prev, ...newPosts]);
      }

      setHasMore(Boolean(data.hasMore));
      setContinuationToken(data.nextContinuationToken || null);
    } catch (err) {
      if (err.name === "AbortError") {
        // Request was canceled intentionally — ignore
        return;
      }
      console.error("❌ Blog fetch failed:", err);
      setError("Failed to fetch blogs");
    } finally {
      setLoading(false);
      // clear current controller
      if (abortControllerRef.current === controller)
        abortControllerRef.current = null;
    }
  };

  // Reload blogs when category changes
  // useEffect(() => {
  //  setContinuationToken(null);
  // fetchBlogs(true);
  // }, [activeCategory]);

  useEffect(() => {
    // Reset UI state immediately
    setBlogs([]);
    setContinuationToken(null);
    setHasMore(true);
    setError(null);

    // Start a clean fetch for this category (explicitly pass category)
    // tokenOverride is null to avoid sending any old token
    fetchBlogs(true, null, activeCategory);
  }, [activeCategory]);

  // Load more blogs when page changes
  // useEffect(() => {
  //   if (page > 1) {
  //     fetchBlogs(false);
  //   }
  // }, [page]);

  // Infinite scroll observer
  //  const lastBlogRef = useCallback(
  //   (node) => {
  //     if (loading) return;
  //     if (observerRef.current) observerRef.current.disconnect();

  //     observerRef.current = new IntersectionObserver((entries) => {
  //       if (entries[0].isIntersecting && hasMore && continuationToken) {
  //         fetchBlogs(false);
  //       }
  //     });

  //     if (node) observerRef.current.observe(node);
  //   },
  //   [loading, hasMore, continuationToken]
  // );

  const lastBlogRef = useCallback(
    (node) => {
      if (loading) return;
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          // use the explicit category and rely on stored continuationToken (no override)
          fetchBlogs(false, null, activeCategory);
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [loading, hasMore, activeCategory] // include activeCategory so observer recreates on category change
  );

  // UI States
  if (loading && blogs.length === 0)
    return (
      <div>
        <LoaderSpiner />
      </div>
    );

  return (
    <div>
      {/* Hero Banner */}
      <div className="relative w-full">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div
          className="relative bg-cover bg-center bg-no-repeat h-96"
          style={{ backgroundImage: `url(${bgimg})` }}
        >
          <div className="relative z-10 top-40 text-center text-white">
            <h2 className="text-6xl w-1/2 -ml-40 font-bold mb-4">INSIGHT</h2>
          </div>
        </div>
      </div>

      {/* Categories Filter */}
      <div className="p-6 mx-auto space-y-6 bg-white max-w-8xl rounded-xl">
        <h2 className="text-4xl font-bold text-center text-gray-800">
          OUR LATEST BLOG
        </h2>
        <div className="flex flex-wrap justify-center gap-4 text-center">
          {categories.map((category, index) => (
            <button
              key={index}
              onClick={() => setActiveCategory(category)}
              className={`px-3 py-2 text-lg font-semibold rounded ${
                activeCategory === category
                  ? "bg-orange-500 text-white"
                  : "bg-gray-200 text-gray-800"
              }`}
            >
              {category.toUpperCase()}
            </button>
          ))}
        </div>
      </div>

      {/* Blog Cards */}
      <div className="w-full p-8 mx-auto max-w-7xl">
        <h2 className="mb-6 text-3xl font-bold">Case Studies</h2>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {blogs?.length > 0 ? (
            blogs.map((blog, index) => {
              const isLastBlog = blogs.length === index + 1;
              return (
                <div
                  ref={isLastBlog ? lastBlogRef : null}
                  key={blog.key}
                  className="items-center overflow-hidden text-center bg-white rounded-lg shadow-xl"
                >
                  {/* Thumbnail */}
                  <img
                    src={
                      blog.thumbnail ||
                      "https://via.placeholder.com/400x200?text=No+Image"
                    }
                    className="object-cover w-full h-48"
                    alt={blog.title || "Blog Image"}
                  />
                  {/* Blog Content */}
                  <div className="p-6">
                    <h3 className="mb-2 text-lg font-semibold">
                      {blog.title || "Untitled"}
                    </h3>
                    {/* <p className="mb-4 text-gray-600">
                      {blog.content
                        ? blog.content
                            .replace(/<[^>]+>/g, "")
                            .substring(0, 200) + "..."
                        : "No content available."}
                    </p> */}

                    <p className="mb-4 text-gray-600">
                      {blog.summary
                        ? blog.summary
                        : blog.content
                        ? blog.content
                            .replace(/<[^>]+>/g, "")
                            .substring(0, 200) + "..."
                        : "No content available."}
                    </p>
                    <Link
                      to={`/insights/${slugify(blog.title)}-${blog.id}`}
                  //  to={`/insights/${blog.title}`}
                      state={{ id: blog.id, blog }}
                    >
                      <button className="p-1 px-2 bg-blue-500 hover:scale-110">
                        <span className="text-sm font-normal text-white">
                          Learn More
                        </span>
                      </button>
                    </Link>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-span-full flex flex-col items-center justify-center py-16 px-4 bg-gray-50 rounded-2xl border border-dashed border-gray-200">
              <svg className="w-16 h-16 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></path>
              </svg>
              <h3 className="text-xl font-semibold text-gray-700 mb-1">No data available yet</h3>
              <p className="text-gray-500 text-sm max-w-xs text-center">
                {error ? `We couldn't retrieve the blogs: ${error}` : "There are currently no articles or case studies published in this category."}
              </p>
            </div>
          )}
        </div>

        {/* Loader Spinner at bottom when fetching */}
        {loading && (
          <div className="flex justify-center mt-6">
            <LoaderSpiner />
          </div>
        )}
      </div>
    </div>
  );
};

export default Blogs;
